/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Portfolio generator


window.addEventListener("DOMContentLoaded", function () {
  // Helper function to normalize category names (replace spaces with hyphens)
  function normalizeCategoryName(name) {
    return name.replace(/\s+/g, "-"); // Replace spaces with hyphens
  }

  // Function to update category description
  function updateCategoryDescription(button) {
    // Get the inner text of the button
    const buttonText = button.innerText.trim();

    // Find the .hidden element with a matching data-category value (case-insensitive)
    const matchingHiddenDiv = Array.from(
      document.querySelectorAll(".hidden")
    ).find(
      (div) =>
        div.dataset.category &&
        div.dataset.category.toLowerCase() === buttonText.toLowerCase()
    );

    // Replace the text inside #category-description if a match is found
    const categoryDescription = document.querySelector("#category-description");
    if (matchingHiddenDiv && categoryDescription) {
      categoryDescription.innerText = matchingHiddenDiv.innerText;
    }
  }

  // Add click event listeners to category buttons
  document.querySelectorAll("[id^='button--']").forEach((button) => {
    button.addEventListener("click", function () {
      // Extract the category name from the button's ID
      const category = this.id.split("button--")[1];

      // Hide or show elements based on the category
      if (category === "all") {
        // Show all .Portfolio--card elements
        document.querySelectorAll(".Portfolio--card").forEach((card) => {
          card.style.display = "block";
        });
      } else {
        // Hide all .Portfolio--card elements
        document.querySelectorAll(".Portfolio--card").forEach((card) => {
          card.style.display = "none";
        });

        // Show only the .Portfolio--card elements with the matching category class
        document
          .querySelectorAll(`.Portfolio--card.${normalizeCategoryName(category)}`)
          .forEach((card) => {
            card.style.display = "block";
          });
      }

      // Remove the 'active' class from all buttons
      document.querySelectorAll("[id^='button--']").forEach((btn) => {
        btn.classList.remove("active");
      });

      // Add the 'active' class to the clicked button
      this.classList.add("active");

      // Update the category description
      updateCategoryDescription(this);
    });
  });

  // Check for the category in the URL query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const categoryParam = urlParams.get("category");

  if (categoryParam) {
    // Normalize the category name
    const normalizedCategory = normalizeCategoryName(categoryParam);
    // Find the button with the corresponding category ID
    const buttonToClick = document.querySelector(`#button--${normalizedCategory}`);

    if (buttonToClick) {
      // Simulate a click on the button with the corresponding category
      buttonToClick.click();
    }
  } else {
    // Load the description for the active button on page load
    const activeButton = document.querySelector("[id^='button--'].active");
    if (activeButton) {
      updateCategoryDescription(activeButton);
    }
  }
});

// Portfolio page image links

window.addEventListener("load", () => {
  // Check if the body has the class `.template-portfolio`
  if (document.body.classList.contains("template-portfolio")) {
    // Select all `.column__inner` elements
    const columnInnerElements = document.querySelectorAll(".column__inner");

    columnInnerElements.forEach((column) => {
      // Find the anchor tags with the class "metafield-url"
      const anchorTags = column.querySelectorAll('a.metafield-url');

      anchorTags.forEach((anchor) => {
        const url = anchor.getAttribute("href");

        // Locate the .column__image within the current column
        const columnImage = column.querySelector(".column__image");

        if (columnImage) {
          // Wrap the .column__image content with the <a> tag if not already wrapped
          if (!columnImage.querySelector("a")) {
            const wrapper = document.createElement("a");
            wrapper.setAttribute("href", url);
            wrapper.setAttribute("target", "_blank");
            wrapper.setAttribute("rel", "noopener noreferrer");

            // Move the existing children into the wrapper
            while (columnImage.firstChild) {
              wrapper.appendChild(columnImage.firstChild);
            }

            // Append the wrapper back to the .column__image element
            columnImage.appendChild(wrapper);
          }
        }
      });
    });
  }
});

// Variant images
document.addEventListener('DOMContentLoaded', () => {

    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput || !window.product) {
        console.warn('Missing variant input or window.product');
        return;
    }

    const productTitle = window.product.title;
    const optionLabels = window.product.options;

    const getReadableVariantString = (variantId) => {
        const variant = window.product.variants.find(v => v.id == variantId);
        if (!variant) return '';
        const optionsString = variant.options
            .map((optionValue, index) => `${optionLabels[index]}: ${optionValue}`)
            .join(' - ');
        return `${productTitle} - ${optionsString}`;
    };

    const decodeHTMLEntities = (str) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    };

    const updateImages = () => {
    const variantId = variantInput.value;
    const readableString = getReadableVariantString(variantId);
    console.log('Readable string:', readableString);

    const normalizeText = (str) => {
        return str
            .normalize("NFD").replace(/\p{Diacritic}/gu, "") // strip accents
            .replace(/\s*:\s*/g, ":") // unify colon spacing
            .replace(/\s+/g, " ") // collapse extra spaces
            .trim()
            .toLowerCase(); // case-insensitive
    };

    const productSlides = document.querySelectorAll('.product__slide');
    const productThumbs = document.querySelectorAll('.product__thumb');

    let activatedSlide = false;
    productSlides.forEach(slide => {
        const altTxtRaw = decodeHTMLEntities(slide.dataset.altTxt || '');
        const altParts = altTxtRaw.split(' _ ').map(s => s.trim());

        const match = altParts.some(
            part => normalizeText(part) === normalizeText(readableString)
        );

        if (match) {
            slide.style.display = '';
            if (!activatedSlide) {
                slide.classList.add('media--active');
                slide.classList.remove('media--hidden');
                activatedSlide = true;
            } else {
                slide.classList.remove('media--active');
                slide.classList.remove('media--hidden');
            }
        } else {
            slide.style.display = 'none';
            slide.classList.remove('media--active');
            slide.classList.add('media--hidden');
        }
    });

    let activatedThumb = false;
    productThumbs.forEach(thumb => {
        const link = thumb.querySelector('a[data-alt-txt]');
        if (!link) {
            thumb.style.display = 'none';
            return;
        }
        const altTxtRaw = decodeHTMLEntities(link.dataset.altTxt || '');
        const altParts = altTxtRaw.split(' _ ').map(s => s.trim());

        const match = altParts.some(
            part => normalizeText(part) === normalizeText(readableString)
        );

        if (match) {
            thumb.style.display = '';
            if (!activatedThumb) {
                thumb.classList.add('media--active');
                activatedThumb = true;
            } else {
                thumb.classList.remove('media--active');
            }
        } else {
            thumb.style.display = 'none';
            thumb.classList.remove('media--active');
        }
    });
};


    // Run on page load
    updateImages();

    // Detect variant changes
    document.addEventListener('change', (e) => {
        if (e.target.name === 'id' || e.target.closest('form')?.id?.startsWith('ProductForm')) {
            setTimeout(updateImages, 50);
        }
    });
});






  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();